<template>
	<div class="layout-navbars-breadcrumb-index">
		<Logo v-if="setIsShowLogo" />
		<Breadcrumb />
		<Horizontal :menuList="menuList" v-if="isLayoutTransverse" />
    <div v-if="!isUniapp" class="layout-logo">
      <img :src="getUserInfos.companyAvatar" class="layout-logo-medium-img" />
      <span>
      {{$store.getters.userInfo.companyName+"("+$store.getters.userInfo.companyNum+")"}}
    </span>
    </div>

    <User/>
	</div>
</template>

<script>
import Breadcrumb from '@/views/layout/navBars/breadcrumb/breadcrumb.vue';
import User from '@/views/layout/navBars/breadcrumb/user.vue';
import Logo from '@/views/layout/logo/index.vue';
import Horizontal from '@/views/layout/navMenu/horizontal.vue';
import { Local } from '@/utils/storage.js';
export default {
	name: 'layoutNavBars',
	components: { Breadcrumb, User, Logo, Horizontal },
	data() {
		return {
			menuList: [],
		};
	},
	computed: {
		// 设置 logo 是否显示
		setIsShowLogo() {
			let { isShowLogo, layout } = this.$store.state.themeConfig.themeConfig;
			return (isShowLogo && layout === 'classic') || (isShowLogo && layout === 'transverse');
		},
		// 设置是否显示横向菜单
		isLayoutTransverse() {
			let { layout, isClassicSplitMenu } = this.$store.state.themeConfig.themeConfig;
			return layout === 'transverse' || (isClassicSplitMenu && layout === 'classic');
		},
    isShowUser(){
      // console.log("isTagsview")
      // if(Local.get("isUniapp")) return false;
      // else return true;
      return true;
    },
    getUserInfos() {
      return this.$store.getters.userInfo;
    },
    isUniapp(){
      return Local.get("isUniapp")? true: false
    },

	},
	mounted() {
		this.setFilterRoutes();
	},
	methods: {
		// 设置路由的过滤
		setFilterRoutes() {
			this.menuList = this.filterRoutesFun(this.$store.state.routesList.routesList);
		},
		// 设置路由的过滤递归函数
		filterRoutesFun(arr) {
			return arr
				.filter((item) => !item.meta.isHide)
				.map((item) => {
					item = Object.assign({}, item);
					if (item.children) item.children = this.filterRoutesFun(item.children);
					return item;
				});
		},
	},
	watch: {
		// 监听 vuex 数据变化
		'$store.state': {
			handler(val) {
				if (val.routesList.routesList.length === this.menuList.length) return false;
				this.setFilterRoutes();
			},
			deep: true,
		},
	},
};
</script>

<style scoped lang="scss">
.layout-navbars-breadcrumb-index {
	height: 50px;
	display: flex;
	align-items: center;
	padding-right: 15px;
	background: var(--bg-topBar);
	overflow: hidden;
	border-bottom: 1px solid #f1f2f3;
}

.layout-logo {
  width: 360px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgb(0 21 41 / 2%) 0px 1px 4px;
  font-size: 22px;
  animation: logoAnimation 0.3s ease-in-out;
  &:hover {
    span {
      opacity: 0.9;
    }
  }
  &-medium-img {
    width: 28px;
    margin-right: 5px;
    position: relative;
    top: 2px;
  }
}

</style>
